import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEDropdown from '../../elements/controls/oe-dropdown';
import {OEPresetSetType, OEPresetTypeHelper} from './oe-preset-model';

export default class OEPresetDropdown extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.selectedPresetId = this.props.selectedPresetId;
        this.presets = [];

        this.state = {
            selectedPresetId:   this.selectedPresetId,
            presets:            [],
        };

        this.onPresetAdded = this.onPresetAdded.bind(this);
        this.onPresetRemoved = this.onPresetRemoved.bind(this);
        this.onPresetChanged = this.onPresetChanged.bind(this);

        this.onDropDownClick = this.onDropDownClick.bind(this);
    }

    getSelectedPresetId() {
        return this.selectedPresetId;
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.presetType, this.props.presetType, true) || nextProps.presetSetType !== this.props.presetSetType) {
            this.updatePresets(nextProps);
        }

        if(nextProps.selectedPresetId !== this.props.selectedPresetId) {
            this.selectedPresetId = nextProps.selectedPresetId;
            this.setState({selectedPresetId: this.selectedPresetId});
        }
    }

    onConnect() {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetAdded, this.onPresetAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetRemoved, this.onPresetRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetChanged, this.onPresetChanged);
    }

    onRelease() {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetAdded, this.onPresetAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetRemoved, this.onPresetRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetChanged, this.onPresetChanged);
    }

    updatePresets(props) {
        if(!this.oe.isReady())  return;
        props = props || this.props;

        let coreType = OEPresetTypeHelper.presetTypeToCore(props.presetType);

        let presetSetData = coreType ? this.oe.sharedInterface.getUIControllerPreset().getPresetSetData(coreType, props.presetSetType) : [];

        this.presets = presetSetData.map(data => {
            return {
                id:         data.id,
                type:       OEPresetTypeHelper.presetTypeFromCore(data.type),
                name:       data.name
            };
        });

        this.setState({presets: clone(this.presets)});
    }

    updateState(released) {
        if(!this.oe.isReady() || released === true) {
            this.presets = [];
            this.setState({
                presets:    [],
            });
            return;
        }

        this.updatePresets();
    }

    onPresetAdded(message, userInfo) {
        this.presets.push({
            id:             userInfo.data.id,
            type:           OEPresetTypeHelper.presetTypeFromCore(userInfo.data.type),
            name:           userInfo.data.name
        });

        this.setState({presets: clone(this.presets)});
    }

    onPresetRemoved(message, userInfo) {
        let index = this.presets.findIndex(preset => preset.id === userInfo.ID);
        if(index < 0)   return;

        this.presets.splice(index, 1);

        this.setState({presets: clone(this.presets)});

        if(userInfo.ID == this.selectedPresetId)    {
            this.selectedPresetId = -1;
            this.setState({selectedPresetId: this.selectedPresetId});
            if(this.props.onPresetSelected) this.props.onPresetSelected(this, this.selectedPresetId);
        }
    }

    onPresetChanged(message, userInfo) {
        let index = this.presets.findIndex(preset => preset.id === userInfo.data.id);
        if(index < 0)   return;

        this.presets[index].name = userInfo.data.name;

        this.setState({presets: clone(this.presets)});
    }

    render() {
        let entries = this.state.presets.map((preset) => { return {key: preset.id, content: <span className="label">{preset.name}</span>}});
        entries.splice(0, 0, {key: -1, content: <span className="label"></span>});

        let selectedPreset = this.state.presets.find(preset => preset.id === this.state.selectedPresetId);
        let title = selectedPreset ? selectedPreset.name : '';

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEDropdown
                    className={this.props.className}
                    title={title}
                    disabled={this.props.disabled || (!this.state.presets.length && this.selectedPresetId < 0)}
                    chosenKey={selectedPreset}
                    entries={entries}
                    onClick={this.onDropDownClick}
                />
            </React.Fragment>
        );
    }

    onDropDownClick(key) {
        this.selectedPresetId = key;
        this.setState({selectedPresetId: this.selectedPresetId});
        if(this.props.onPresetSelected) this.props.onPresetSelected(this, this.selectedPresetId);
    }
}

OEPresetDropdown.defaultProps = {
    moduleId:                   '',
    className:                  '',
    disabled:                   false,
    presetSetType:              OEPresetSetType.static,
    selectedPresetId:           -1
};

OEPresetDropdown.propTypes = {
    moduleId:                   PropTypes.string,
    className:                  PropTypes.string,
    disabled:                   PropTypes.bool,
    presetType:                 OEPresetTypeHelper.presetTypeDecl,
    presetSetType:              PropTypes.oneOf([OEPresetSetType.static, OEPresetSetType.modelState]),
    selectedPresetId:           PropTypes.number,
    onPresetSelected:           PropTypes.func
};